module.exports = __webpack_public_path__ + "img/174-corsica.141764f2.svg";